"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Surveillances = void 0;
const lodash_1 = require("lodash");
const utils_1 = require("./utils");
const surveillance_1 = require("./surveillances/surveillance");
const injection_1 = require("./surveillances/injection");
const medicationWithFlows_1 = require("./surveillances/medicationWithFlows");
const medicationV2_1 = require("./surveillances/medicationV2");
const medication_1 = require("./surveillances/medication");
const surveillanceInitial_1 = require("./surveillances/surveillanceInitial");
const medicationWithBoli_1 = require("./surveillances/medicationWithBoli");
class Surveillances {
    constructor(bilan) {
        this.formatInjectionV2 = () => {
            let injectedProtocols = [];
            injectedProtocols.push({ protocolId: null, protocolName: "Hors protocole", injections: [] });
            let asu = 'Actes de soins d\'urgence';
            this.injectionsV2.forEach(medication => {
                let medicationV2 = medication;
                switch (true) {
                    case (medicationV2.prescription_header_id != null):
                        let pAsu = injectedProtocols.find(it => it.protocolId === null && it.protocolName === asu);
                        if (pAsu)
                            pAsu.injections.push(medication);
                        else
                            injectedProtocols.push({
                                protocolId: null,
                                protocolName: asu,
                                injections: [medication],
                            });
                        break;
                    case (medication.nursing_protocol_name && medication.nursing_protocol_name !== ""):
                        let p = injectedProtocols.find(it => it.protocolId === null && it.protocolName === medication.nursing_protocol_name);
                        if (p)
                            p.injections.push(medication);
                        else
                            injectedProtocols.push({
                                protocolId: null,
                                protocolName: medication.nursing_protocol_name,
                                injections: [medication]
                            });
                        break;
                    case (medicationV2.intervention_protocol != null):
                        let p2 = injectedProtocols.find(it => it.protocolId === medicationV2.intervention_protocol?.id);
                        if (p2)
                            p2.injections.push(medication);
                        else
                            injectedProtocols.push({
                                protocolId: medicationV2.intervention_protocol?.id,
                                protocolName: medicationV2.intervention_protocol?.name,
                                injections: [medication]
                            });
                        break;
                    default:
                        injectedProtocols[0].injections.push(medication);
                }
            });
            if (injectedProtocols[0].injections.length === 0)
                injectedProtocols.splice(0, 1);
            return (injectedProtocols.length === 1 && injectedProtocols[0].injections.length === 0) ? [] : injectedProtocols;
        };
        /** Formate les surveillances
         *
         * Identifie la présence d'une spec au sein des surveillances
         */
        this.formatSurv = (bilan) => {
            let tempEntry = (0, lodash_1.clone)(bilan.surveillances.filter(s => s.heure !== '-1' || s.surv_heure)).map(s => {
                s.heure = surveillance_1.SurveillanceImpl.extractHours(s);
                s.minute = surveillance_1.SurveillanceImpl.extractMinutes(s);
                return s;
            });
            tempEntry = (0, utils_1.sortSurv)(tempEntry, (s) => s.surv_heure);
            const tempExit = [];
            /** Adds the index of the monitoring */
            for (let idx = 0; idx < tempEntry.length; idx++) {
                const item = tempEntry[idx];
                const s = new surveillance_1.SurveillanceImpl(idx, item, this.hasSpo2o2, this.hasDispoOxy, this.isSpo2AA, bilan.medic_info.glycemie_unite);
                item.medics.forEach(med => {
                    const elem = new injection_1.InjectionImpl(med);
                    this.medics.push(elem);
                    if (elem.comment && !this.hasComment)
                        this.hasComment = true;
                });
                tempExit.push(s);
            }
            return tempExit;
        };
        /** Retourne la surveillance initiale */
        this.getInitales = () => {
            return this.initial;
        };
        /** Retourne les surveillances */
        this.getSurveillances = () => {
            return this.surveillances;
        };
        /** Retourne les injections */
        this.getInjections = () => {
            let temp = [];
            temp.push(...this.iv_fluids, ...this.medications, ...this.injectionsV2, ...this.medicaments, ...this.medics);
            temp = (0, utils_1.sortSurv)(temp, (e) => e.date);
            return temp;
        };
        /** Retourne la surveillance initiale et les surveillances */
        this.getInitSurveillances = () => {
            const temp = (0, lodash_1.cloneDeep)(this.surveillances);
            temp.unshift(this.initial);
            return temp;
        };
        /** Retourne les surveillances et les injections */
        this.getSurveillancesInject = () => {
            let temp = (0, lodash_1.cloneDeep)(this.surveillances);
            temp.push(...this.iv_fluids, ...this.medications, ...this.injectionsV2, ...this.medicaments, ...this.medics);
            temp = (0, utils_1.sortSurv)(temp, (e) => e.date);
            return temp;
        };
        /** Retourne la surveillance initiale, les surveillances et les injections */
        this.getInitSurveillancesInject = () => {
            let injColDefModel = [];
            this.injectionsV2.forEach(medication => {
                let found = injColDefModel.find(it => it.date && medication.date
                    ? it.date.day === medication.date.day && it.heure === medication.heure && it.minute === medication.minute
                    : it.heure === medication.heure && it.minute === medication.minute);
                if (found)
                    found.injections.push(medication);
                else
                    injColDefModel.push({
                        type: 'injection',
                        v2: true,
                        date: medication.date,
                        heure: medication.heure,
                        minute: medication.minute,
                        injections: [medication]
                    });
            });
            let temp = (0, lodash_1.cloneDeep)(this.surveillances);
            temp.push(...this.iv_fluids, ...this.medications, ...injColDefModel, ...this.medicaments, ...this.medics);
            temp = (0, utils_1.sortSurv)(temp, (e) => e.date);
            temp.unshift(this.initial);
            return temp;
        };
        /**
         * Permet d'identifier la première et dernière surveillance non vide
         * @params survs - Tableau de surveillances
         * */
        this.identifiesFirstAndLast = (survs) => {
            let hasLast = false;
            let hasFirst = false;
            for (let i = survs.length - 1, j = survs.length; i > -1; i--) {
                const isLast = !hasLast && !survs[i].isEmpty ? true : false;
                survs[i].last = isLast;
                if (!hasLast && isLast !== hasLast)
                    hasLast = isLast;
            }
            for (let i = 0; i < survs.length; i++) {
                const isFirst = !hasFirst && !survs[i].isEmpty ? true : false;
                survs[i].first = isFirst;
                if (!hasFirst && isFirst !== hasFirst)
                    hasFirst = isFirst;
            }
            return survs;
        };
        this.hasDispoOxy = bilan.geste.dispositif_oxygeno !== 0;
        this.isSpo2AA = bilan.geste.dispositif_oxygeno === 1;
        this.hasSpo2o2 = bilan.respiration.o2o2 !== -1 && bilan.respiration.o2o2 !== null;
        this.hasInconscience = false;
        this.hasFr = false;
        this.hasO2aa = false;
        this.hasO2o2 = false;
        this.hasDebitO2 = false;
        this.hasDispositifOxygeno = false;
        this.hasSpco = false;
        this.hasSpcoPpm = false;
        this.hasEtco2 = false;
        this.hasRespirateurFr = false;
        this.hasRespirateurFio2 = false;
        this.hasRespirateurVt = false;
        this.hasRespirateurPep = false;
        this.hasPeakFlow = false;
        this.hasFc = false;
        this.hasPabd = false;
        this.hasPambd = false;
        this.hasPabg = false;
        this.hasPambg = false;
        this.hasPamd = false;
        this.hasPamg = false;
        this.hasPamByUser = false;
        this.hasTensionMoyenne = false;
        this.hasTensionManuelleSystolique = false;
        this.hasTensionManuelleSystoliqueGauche = false;
        this.hasTensionManuelleSystoliqueDroite = false;
        this.hasHemoglobine = false;
        this.hasHemocue = false;
        this.hasShockIndex = false;
        this.hasChocDate = false;
        this.hasChocTime = false;
        this.hasNbChoc = false;
        this.hasGlycemie = false;
        this.hasAvpu = false;
        this.hasEva = false;
        this.hasPupilles = false;
        this.hasGlasgow = false;
        this.hasScoreSed = false;
        this.hasHemoglobineFloat = false;
        this.hasTemperature = false;
        this.hasTemperatureZone = false;
        this.hasComment = false;
        this.hasApgar = false;
        this.hasApgarScore = false;
        this.hasMALINASScore = false;
        this.hasNIHSSScore = false;
        this.hasObst = false;
        this.hasTrc = false;
        this.hasHbco = false;
        this.hasPaleur = false;
        this.hasChockIndex = false;
        this.iv_fluids = [];
        this.medications = [];
        this.injectionsV2 = [];
        this.injectedProtocols = [];
        this.medicaments = [];
        this.medics = [];
        this.initial = new surveillanceInitial_1.SurveillanceInitialImpl(bilan);
        /** Surveillances + medics contenu dans les surveillances */
        this.surveillances = this.formatSurv(bilan);
        /** Extract the iv_fluids and medications to add them to the monitors */
        bilan.injections.forEach(i => {
            if (i.deleted_at === null) {
                if (i.v2 && i.started_at !== null) {
                    if (!i.flow_rate && !i.can_boli) {
                        this.injectionsV2.push(new medicationV2_1.MedicationV2Impl(i));
                    }
                    else if (i.can_boli && i.boli && i.boli.length > 0) {
                        let i_boli = (0, utils_1.sortSurv)(i.boli, (e) => e.started_at);
                        i_boli.forEach(bolus => this.injectionsV2.push(new medicationWithBoli_1.MedicationBolusImpl(i, bolus)));
                    }
                    else if (i.flows && i.flows.length > 0) {
                        let i_flows = (0, utils_1.sortSurv)(i.flows, (e) => e.started_at);
                        i_flows.forEach((flow, idx) => this.injectionsV2.push(new medicationWithFlows_1.MedicationFlowImpl(i, flow, idx)));
                    }
                    this.injectedProtocols = this.formatInjectionV2();
                }
                else {
                    if (i.iv_fluids.length > 0) {
                        i.iv_fluids.forEach(medicData => {
                            this.iv_fluids.push(new medication_1.MedicationImpl(i, medicData));
                        });
                    }
                    if (i.medications.length > 0) {
                        i.medications.forEach(medicData => {
                            this.medications.push(new medication_1.MedicationImpl(i, medicData));
                        });
                    }
                }
            }
        });
        if (!this.hasComment && this.iv_fluids.some(iv => iv.comment))
            this.hasComment = true;
        if (!this.hasComment && this.medications.some(med => med.comment))
            this.hasComment = true;
        if (!this.hasComment && this.injectionsV2.some(inj => inj.comment))
            this.hasComment = true;
        bilan.medicaments.forEach(i => {
            const elem = new injection_1.InjectionImpl(i);
            this.medicaments.push(elem);
            if (elem.comment && !this.hasComment)
                this.hasComment = true;
        });
        /** Identifie la présence d'une spec dans les surveillances */
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.inconscience !== null))
            this.hasInconscience = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.fr !== null))
            this.hasFr = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.fc !== null))
            this.hasFc = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.spco !== null))
            this.hasSpco = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.o2aa !== null || e.spo2 !== null))
            this.hasO2aa = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.o2o2 !== null || e.spo2_with_o2 !== null))
            this.hasO2o2 = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.debit_o2 !== null || e.oxy_debit !== null))
            this.hasDebitO2 = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.dispositif_oxygeno !== null && e.dispositif_oxygeno !== 0))
            this.hasDispositifOxygeno = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.etco2 !== null))
            this.hasEtco2 = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.respirateur_fr !== null))
            this.hasRespirateurFr = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.respirateur_fio2 !== null))
            this.hasRespirateurFio2 = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.respirateur_vt !== null))
            this.hasRespirateurVt = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.respirateur_pep !== null))
            this.hasRespirateurPep = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.peak_flow !== null))
            this.hasPeakFlow = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.pabd !== null))
            this.hasPabd = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.pabg !== null))
            this.hasPabg = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.pambd !== null))
            this.hasPambd = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.pambg !== null))
            this.hasPambg = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.pamd !== null))
            this.hasPamd = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.pamg !== null))
            this.hasPamg = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.is_pam_entry_by_user !== null))
            this.hasPamByUser = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.tension_moyenne !== null))
            this.hasTensionMoyenne = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.tension_manuelle_systolique !== null))
            this.hasTensionManuelleSystolique = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.tension_manuelle_systolique_gauche !== null))
            this.hasTensionManuelleSystoliqueGauche = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.tension_manuelle_systolique_droite !== null))
            this.hasTensionManuelleSystoliqueDroite = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.hemoglobine !== null))
            this.hasHemoglobine = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.hemocue !== null))
            this.hasHemocue = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.shockIndex !== null))
            this.hasShockIndex = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.choc_index !== null))
            this.hasChockIndex = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.choc_date !== null))
            this.hasChocDate = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.choc_time !== null))
            this.hasChocTime = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.nb_choc_total !== null))
            this.hasNbChoc = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.pupilles !== null || e.pupilles_bilateral !== null))
            this.hasPupilles = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.glasgow !== null || e.gla_yeux !== null || e.gla_parole !== null || e.gla_motricite !== null))
            this.hasGlasgow = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.glycemie !== null))
            this.hasGlycemie = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.avpu !== null))
            this.hasAvpu = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.score_sedation !== null))
            this.hasScoreSed = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.hemoglobine_float !== null))
            this.hasHemoglobineFloat = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.temperature !== null))
            this.hasTemperature = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.temperature_zone !== null))
            this.hasTemperatureZone = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.hbco !== null))
            this.hasHbco = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.trc !== null))
            this.hasTrc = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.paleur !== null))
            this.hasPaleur = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.eva !== null))
            this.hasEva = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.comment !== null))
            this.hasComment = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.apgar_score !== null))
            this.hasApgarScore = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.malinas !== null))
            this.hasMALINASScore = true;
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.nihss !== null))
            this.hasNIHSSScore = true;
        // APGAR
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.apgar &&
            (e.apgar.fr !== null ||
                e.apgar.fc !== null ||
                e.apgar.tonus !== null ||
                e.apgar.reactivite !== null ||
                e.apgar.coloration !== null)))
            this.hasApgar = true;
        // OBSTETRIQUE
        if ((0, lodash_1.some)([this.initial, ...this.surveillances], (e) => e.obst &&
            (e.obst.malinas_parite !== null ||
                e.obst.malinas_travail !== null ||
                e.obst.malinas_duree_contraction !== null ||
                e.obst.malinas_intervalle_contraction !== null ||
                e.obst.malinas_perte_eaux !== null ||
                e.obst.nombre_pars !== null ||
                e.obst.duree_contractions !== null ||
                e.obst.intervalle_contraction !== null ||
                e.obst.intervalle_contraction_sec !== null ||
                e.obst.contraction !== null ||
                e.obst.perte_eaux !== null)))
            this.hasObst = true;
        // MEDICS COMMENTAIRE
        if ((0, lodash_1.some)(this.medics, e => e.comment !== null))
            this.hasComment = true;
    }
}
exports.Surveillances = Surveillances;
